import React, { startTransition } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getTheme } from 'app/components/ThemeProvider/theme';
import { useMediaQuery } from '@mui/material';

const useHeader = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);
  const isHistoryLocation = location.pathname.includes('last-operation');
  const theme = getTheme();
  const mediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const largeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUserProfile = () => {
    startTransition(() => {
      navigate(`${lang}/profile?type=information`);
    });
    setAnchorEl(null);
  };

  const handleLogout = () => {
    startTransition(() => {
      navigate(`${lang}/login`);
    });
    sessionStorage.clear();
    setAnchorEl(null);
  };

  const handleRedirectTransfer = () => {
    startTransition(() => {
      navigate(`${lang}/transfer-page`);
    });
  };

  const handleRedirectLastOperations = () => {
    startTransition(() => {
      navigate(`${lang}/last-operations`);
    });
  };

  return {
    t,
    isHistoryLocation,
    open,
    anchorEl,
    handleClick,
    handleClose,
    handleRedirectTransfer,
    handleRedirectLastOperations,
    mediumScreen,
    largeScreen,
    handleLogout,
    handleUserProfile,
  };
};

export default useHeader;
